module.exports = __webpack_public_path__ + "static/table-280d4dfffb1cd3caea9e67fd28a03468.svg";